export const apiUrl= 'https://service.mavenconnect.tech/api/';
// export const apiUrl = 'http://localhost:2323/api/';
export const apiConfig = {
    user: "mtpl-vms",
    pass: "vms@Maven$2021#",
    key: "5893747"
}
